<template >
  <div class="wrap" :style="finallyStyle+shapeStyle">
    <div class="content" :style="textStyle">
      <div  v-text="content"></div>
      <!--  如果array  需要 style指定当前字style   word 指定当前字 -->
    </div>
  </div>
</template>
<script>
import positionMixin from "./positionMixin";
export default {
  mixins: [positionMixin],
  data() {
    return {};
  },
  computed: {
    shapeStyle() {
      
      return `width:${this.widthStyle}px;`;
    }
  },
  props: {
    widthStyle: {
      type: [Number, String],
      required: true
    },
    content: {
      type: [String],

      default: "..."
    },
    textStyle: {
      type: [String, Object],
      default: ""
    }
  }
};
</script>
<style lang='stylus' scoped>
.wrap {
  $BoxColor = #fff;
  font-size: 30px;
  font-weight: 100;
  word-spacing: 3px;
  letter-spacing: 5px;
  padding: 50px;
  color: $BoxColor;
  text-align: center;
  position: absolute;
  border: 3px dotted $BoxColor;
  border-radius: 50%;

  .content {

    display: flex;
    word-break break-all;
  }
}
</style>
